import {useLazyQuery} from "@apollo/client";
import get from "lodash/get";
import {useFormContext} from "react-hook-form";

import {SelectField, SelectFieldBaseProps} from "@/components/form/fields/SelectField/SelectField.tsx";
import {Select} from "@/components/select/Select.tsx";
import {useLoadOptions} from "@/lib/hooks/useLoadOptions.ts";
import {GQL_TIMEZONES, TimezoneResult} from "@/lib/queries/common.ts";
import {TimezoneInfo} from "@/lib/types/common.ts";

export const TimezoneSelectField = ({name, isSearchable = true, label = "Timezone", ...rest}: SelectFieldBaseProps) => {
  const {
    watch,
    setValue,
    formState: {defaultValues},
  } = useFormContext();
  const value = watch(name);
  const defaultValue = get(defaultValues, name);

  const [getTimezones] = useLazyQuery<TimezoneResult>(GQL_TIMEZONES);
  const {options: timezones, isLoading} = useLoadOptions<TimezoneInfo, TimezoneResult, false>({
    options: undefined,
    fetchOptions: getTimezones,
    transform: (result) => Array.from(result.data?.timezones || []),
  });

  return (
    <SelectField
      name={name}
      isSearchable={isSearchable}
      label={label}
      {...rest}
      select={
        <Select<TimezoneInfo>
          options={timezones}
          isLoading={isLoading}
          defaultValue={timezones.find((timezone) => timezone.name === defaultValue)}
          getOptionValue={(timezone: TimezoneInfo) => timezone.name}
          getOptionLabel={(timezone: TimezoneInfo) => `(${timezone.base_offset_display}) ${timezone.city}`}
          onChange={(v) => setValue(name, v?.name || "")}
          value={timezones.find((timezone) => timezone.name === value)}
        />
      }
    />
  );
};
